import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { DxDataGridComponent } from "devextreme-angular";
import CustomStore from "devextreme/data/custom_store";
import { confirm } from "devextreme/ui/dialog";
import notify from "devextreme/ui/notify";
import { ClipboardService } from "ngx-clipboard";
import { forkJoin, lastValueFrom } from "rxjs";
import { FileTransfersService, IOcbApiDescriptionParameter } from "../../core";

@Component({
    selector: 'app-file-transfer-api-keys',
    templateUrl: './file-transfer-api-keys.component.html'
})
export class FileTransferApiKeysComponent implements AfterViewInit {
    @ViewChild('apiKeysGrid', { static: true }) dataGrid?: DxDataGridComponent;

    protected dataSource: any;
    
    private fileTransferId: string;

    constructor(private fileTransfersService: FileTransfersService,
        private route: ActivatedRoute,
        private clipboardService: ClipboardService,
        private translateService: TranslateService) {
        this.onCopyApiKeyClick = this.onCopyApiKeyClick.bind(this);
        this.onResetApiKeyClick = this.onResetApiKeyClick.bind(this);
    }

    ngAfterViewInit() {
        this.route.params.subscribe(_ => {
            if (this.route.snapshot.params.ft === 'new') return;
            this.fileTransferId = this.route.snapshot.params.ft;

            this.dataSource = new CustomStore({
                key: 'id',
                load: async () => {
                    const query$ = this.fileTransfersService.getApiKeys(this.fileTransferId);
                    const response = await lastValueFrom(query$);
                    return {
                        data: response,
                        totalCount: response.length
                    };
                },
                insert: (value) => {
                    const d = {
                        description: value.description,
                    } as IOcbApiDescriptionParameter;

                    const query$ = this.fileTransfersService.addApiKey(this.fileTransferId, d);
                    return lastValueFrom(query$);
                },
                update: (key, value) => {
                    const d = {
                        description: value.description,
                    } as IOcbApiDescriptionParameter;

                    const query$ = this.fileTransfersService.updateApiKey(this.fileTransferId, key, d);
                    return lastValueFrom(query$);
                },
                remove: (key) => {
                    const query$ = this.fileTransfersService.deleteApiKey(this.fileTransferId, key);
                    return lastValueFrom(query$);
                }
            });

        });
    }

    private handleError(error: any): void {
        let message: '';
        if (error instanceof HttpErrorResponse) {
            if (error.error.hasOwnProperty('message')) message = error.error.message;
            else if (error.error.hasOwnProperty('name')) message = error.error.name;
            else message = error.error;
        }
        else message = error;
        notify(message, 'error', 3000);
    }


    public isCopyIconVisible(e) { return !e.row.isEditing; }

    public isResetIconVisible(e) { return !e.row.isEditing; }

    public onAddButtonClick(e: any) {
        this.dataGrid?.instance.addRow();
        e?.event?.preventDefault();
    }

    public onCopyApiKeyClick(e) {
        this.clipboardService.copy(e.row.data.apiKey);
        this.translateService.get('_clipboard.copied').subscribe(message => notify(message, 'success', 3000));
    }

    public onRefreshButtonClick() {
        if (!this.dataGrid) return;
        this.dataGrid.instance.refresh();
    }

    public onResetApiKeyClick(e) {
        forkJoin({
            msgConfirmMessage: this.translateService.get('apiKeys.msgResetConfirm'),
            msgConfirmTitle: this.translateService.get('apiKeys.msgResetConfirmTitle'),
            msgResetCompleted: this.translateService.get('apiKeys.msgResetComplete')
        })
            .subscribe({
                next: (data) => {
                    let confirmResult = confirm(data.msgConfirmMessage, data.msgConfirmTitle);
                    confirmResult.then((result) => {
                        if (!result) return;
                        this.fileTransfersService.resetApiKey(this.fileTransferId, e.row.data.id).subscribe({
                            next: () => notify(data.msgResetCompleted, 'success', 3000),
                            error: (e) => this.handleError(e)
                        });
                    });
                },
                error: (e) => this.handleError(e)
            });
    }
}